import { Environment } from "./environment.model";

export const environment: Environment = {
    production: false,
    appVersion: "development",
    authConfig: {
        issuer: "https://test-sts.smdstools.com",
        //issuer: "https://localhost:5000",
        redirectUri: "http://localhost:4200",
        clientId: "SMDS-Public-Code-Client",
        responseType: "code",
        scopes: "openid offline_access IdentityServerApi ProfileAPI ConsentAPI",
        validateCprUrl: "https://test-smds-profile.smdstools.com/validate-ssn",
        idp: "MitIdPersonal",
    },
    backendUrl: "https://localhost:7279",
    cmsCacheExpiration: 10000,
    formioPremiumLicense: "eyJhbGciOiJQUzI1NiJ9.eyJsaWNlbnNlTmFtZSI6IlNZTkxBQiBMaWJyYXJ5IExpY2Vuc2UiLCJpYXQiOjE3NDU4OTkyMDAsImV4cCI6MTc3NzQ3ODQwMCwiZmFpbERhdGUiOjE3ODAwNzA0MDAsInRlcm1zIjp7InByZW1pdW0iOnRydWUsIm9mZmxpbmUiOnRydWUsImVudGVycHJpc2VCdWlsZGVyIjpmYWxzZSwicmVwb3J0aW5nIjpmYWxzZSwic3FsY29ubmVjdG9yIjpmYWxzZSwiZW5kcG9pbnRzIjpbIndlYi1wYXRpZW50LmRrIiwiKi5zbWRzdG9vbHMuY29tIl0sImhvc3RuYW1lcyI6WyJ3ZWItcGF0aWVudC5kayIsIiouc21kc3Rvb2xzLmNvbSJdfSwiaXNzIjoiaHR0cHM6Ly9mb3JtLmlvIiwic3ViIjoiRm9ybS5pbyJ9.ue9HuVNeUG5Y1b4O1sj0tFQ6x9P0mmLofMISd8CxTPKzhp1I7mTbfBTefmMh5lvc53S5SNWiLTkpyi2_srxX9RjnNq7h3yagNNcKoS1GDmQ6N4tSi-knklmtzacXhIcq-JHbFIYCCA6pPhzjIluY5Mv18X9-5irZQ7rzj5g3HF5w1RLLGup8C7-70bDwK_gFi2nbt-q6QEkAbAzYQHAwmviwkxXnVeqLDpbmaPKPFqfVF5970lOaq0ipPf6KqcR6MsxMFydb-_BcMkV1HwNqyvwAsLVv8dinyBhr1tH0EK0WmvDjiTlROGnIxLtRnBlc4iBTvzkTlglIo9AhwW-OXQ",
    checkFogpForms: true,
    fogpRedirectUrl: "https://test-web-patient.smdstools.com/Auth/InitLogin",
    favicon: "knap"
};